import { useCallback, useEffect, useRef, useState } from "react";

/** README §Screens 4: 2.6秒で自動的に消えるトースト。施策メイン/詳細/登録モーダルで共有する。 */
export function useToast() {
  const [message, setMessage] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  const showToast = useCallback((msg: string) => {
    if (timer.current) clearTimeout(timer.current);
    setMessage(msg);
    timer.current = setTimeout(() => setMessage(""), 2600);
  }, []);

  return { toastMessage: message, showToast };
}
